export namespace Environment {
  export const firebase = {
    apiKey: 'AIzaSyABgQ5J5pM9KzhaitjsM0YM7-5-2-XPzMo',
    authDomain: 'lamosa-pro.firebaseapp.com',
    databaseURL: 'https://lamosa-pro.firebaseio.com',
    projectId: 'lamosa-pro',
    storageBucket: 'lamosa-pro.firebasestorage.app',
    messagingSenderId: '721933880755'
  };
  export const loading = { spinner: 'circles' };
  export const toast: { position: 'bottom' | 'top' | 'middle' } = { position: 'bottom' };
  export const toastDuration = 5000;
  export const firebaseRoomCollection: string = 'rooms/';
  export const firebaseUserCollection: string = 'users/';
  export const API_BASE_URL_V2 = 'https://api.empatica.io';
  export const environmentStatus: 'prod' | 'demo' = 'prod';
  export const platform: 'mobile' | 'web' = 'mobile';
  export const CLIENT_ID = 95;
  export const AVAILABLE_LOGINS = ['ONE_STEP_LOGIN'];
  export const LOGIN_TERMS = false;
  export const AZURE_OAUTH_TENANT = null;
  export const AZURE_OAUTH_CLIENT_ID = null;
  export const AVAILABLE_LANGUAGES = ['es', 'pt', 'pl', 'en'];
  export const DEFAULT_LANGUAGE = 'es';
  export const REGISTER = false;
}
